const pageNameKey = "addNewGatewayDrawerModal";

export const addNewGatewayDrawerModalEn = {
  [pageNameKey]: {
    title: "Adding Gateway",
    caretAltText: "Caret",
    gatewayOnboardingSection: "Gateway Onboarding",
    onboardingKey: "Onboarding Key",
    help: "Help",
    onboardingKeyHelpText:
      "You find the Onboarding Key printed on the Gateway device.\nExample: 000001918012-000000022944",
    connectGatewayButton: "Connect Gateway",
    announcingGateway: "Gateway announcing to Things OS",
    onboardingGateway: "Gateway onboarding",
    announcedSuccess: "Gateway is announced to Things OS",
    onboardedSuccess: "Gateway is onboarded",
    announceFailed: "Gateway failed to announce to Things OS.",
    onboardFailed: "Gateway failed to onboard",
    connectionFailed: "Connection failed",
    gatewayAlreadyOnboarded:
      "Gateway already exists.\nA gateway with this onboarding key is already registered in Things OS. You cannot add it again.",
    gatewayConnectionNotEstablished:
      "The gateway could not be found or did not reconnect.",
    continueMachineOnboardingDisabled: "Gateway onboarding in progress",
    operationPendingWarningMessage:
      "Connection state is still in IDLE or IN_PROGRESS - You might see the source appear in the list if the process is concluded successfully.",
    retry: "Retry",
    onboardAnotherGateway: "Onboard Another Gateway",
    showProtocol: "Show Protocol",
    hideProtocol: "Hide Protocol",
    getSupport: "Get Support",
    finishAndGoToGateway: "Finish And Go to New Gateway",
    continueMachineOnboarding: "Continue Machine Onboarding",
    showGatewayDetails: "Show Gateway Details",
    gatewayId: "Gateway ID",
    gatewayUuid: "Gateway UUID",
    gatewayName: "Gateway Name",
    vendorId: "Vendor ID",
    model: "Model",
    createdAt: "Created At",
    lastSeen: "Last Seen",
    errorLabel: "Error",
    statusIconAltText: "Status",
    invalidOnboardingKeyErrorMessage:
      "Onboarding key must be at least 25 characters long and can only include letters, numbers, and hyphens.",
  },
};

export const addNewGatewayDrawerModalPtBr = {
  [pageNameKey]: {
    title: "Adicionando gateway",
    caretAltText: "Cursor de texto",
    gatewayOnboardingSection: "Integração do gateway",
    onboardingKey: "Chave de integração",
    help: "Ajuda",
    onboardingKeyHelpText:
      "Você encontra a Chave de Integração impressa no dispositivo Gateway.\nExemplo: 000001918012-000000022944",
    connectGatewayButton: "Conectar gateway",
    announcingGateway: "Gateway anunciando ao Things OS",
    onboardingGateway: "Integração do gateway",
    announcedSuccess: "Gateway anunciado ao Things OS",
    onboardedSuccess: "Gateway integrado",
    announceFailed: "Falha ao anunciar o gateway ao Things OS.",
    onboardFailed: "Falha ao integrar o gateway",
    connectionFailed: "Falha na conexão",
    gatewayAlreadyOnboarded:
      "O gateway já existe.\nUm gateway com esta chave de integração já está registrado no Things OS. Você não pode adicioná-lo novamente.",
    gatewayConnectionNotEstablished:
      "O gateway não foi encontrado ou não se reconectou.",
    continueMachineOnboardingDisabled: "Gateway onboarding in progress",
    operationPendingWarningMessage:
      "O estado da conexao ainda e IDLE ou IN_PROGRESS - A origem pode aparecer na lista se o processo for concluido com sucesso.",
    retry: "Tentar novamente",
    onboardAnotherGateway: "Integrar outro gateway",
    showProtocol: "Mostrar protocolo",
    hideProtocol: "Ocultar protocolo",
    getSupport: "Obter suporte",
    finishAndGoToGateway: "Concluir e ir para o novo gateway",
    continueMachineOnboarding: "Continuar integração da máquina",
    showGatewayDetails: "Mostrar detalhes do gateway",
    gatewayId: "ID do gateway",
    gatewayUuid: "UUID do gateway",
    gatewayName: "Nome do gateway",
    vendorId: "ID do fornecedor",
    model: "Modelo",
    createdAt: "Criado em",
    lastSeen: "Visto pela última vez",
    errorLabel: "Erro",
    statusIconAltText: "Status",
    invalidOnboardingKeyErrorMessage:
      "A chave de integração deve ter pelo menos 25 caracteres e pode incluir apenas letras, números e hífens.",
  },
};

export const addNewGatewayDrawerModalDe = {
  [pageNameKey]: {
    title: "Gateway hinzufügen",
    caretAltText: "Caret",
    gatewayOnboardingSection: "Gateway-Onboarding",
    onboardingKey: "Onboarding-Schlüssel",
    help: "Hilfe",
    onboardingKeyHelpText:
      "Sie finden den Onboarding-Schlüssel aufgedruckt auf dem Gateway-Gerät.\nBeispiel: 000001918012-000000022944",
    connectGatewayButton: "Gateway verbinden",
    announcingGateway: "Gateway kündigt sich bei Things OS an",
    onboardingGateway: "Gateway-Onboarding",
    announcedSuccess: "Gateway ist bei Things OS angekündigt",
    onboardedSuccess: "Gateway ist onboarded",
    announceFailed: "Gateway konnte nicht bei Things OS angekündigt werden.",
    onboardFailed: "Gateway-Onboarding fehlgeschlagen",
    connectionFailed: "Verbindung fehlgeschlagen",
    gatewayAlreadyOnboarded:
      "Das Gateway existiert bereits.\nEin Gateway mit diesem Onboarding-Schlüssel ist bereits in Things OS registriert. Sie können es nicht erneut hinzufügen.",
    gatewayConnectionNotEstablished:
      "Das Gateway wurde nicht gefunden oder nicht wieder verbunden.",
    continueMachineOnboardingDisabled: "Gateway onboarding in progress",
    operationPendingWarningMessage:
      "Der Verbindungsstatus ist noch IDLE oder IN_PROGRESS - Die Quelle kann in der Liste erscheinen, wenn der Vorgang erfolgreich abgeschlossen wird.",
    retry: "Erneut versuchen",
    onboardAnotherGateway: "Weiteres Gateway onboarden",
    showProtocol: "Protokoll anzeigen",
    hideProtocol: "Protokoll ausblenden",
    getSupport: "Support erhalten",
    finishAndGoToGateway: "Abschließen und zum neuen Gateway gehen",
    continueMachineOnboarding: "Maschinen-Onboarding fortsetzen",
    showGatewayDetails: "Gateway-Details anzeigen",
    gatewayId: "Gateway-ID",
    gatewayUuid: "Gateway-UUID",
    gatewayName: "Gateway-Name",
    vendorId: "Hersteller-ID",
    model: "Modell",
    createdAt: "Erstellt am",
    lastSeen: "Zuletzt gesehen",
    errorLabel: "Fehler",
    statusIconAltText: "Status",
    invalidOnboardingKeyErrorMessage:
      "Der Onboarding-Schlüssel muss mindestens 25 Zeichen lang sein und darf nur Buchstaben, Zahlen und Bindestriche enthalten.",
  },
};

export const addNewGatewayDrawerModalZhHans = {
  [pageNameKey]: {
    title: "添加网关",
    caretAltText: "Caret",
    gatewayOnboardingSection: "网关入门",
    onboardingKey: "入门密钥",
    help: "帮助",
    onboardingKeyHelpText:
      "您可以在网关设备上找到印刷的入门密钥。\n示例：000001918012-000000022944",
    connectGatewayButton: "连接网关",
    announcingGateway: "网关正在向 Things OS 通告",
    onboardingGateway: "网关入门",
    announcedSuccess: "网关已向 Things OS 通告",
    onboardedSuccess: "网关已入门",
    announceFailed: "网关未能向 Things OS 通告。",
    onboardFailed: "网关入门失败",
    connectionFailed: "连接失败",
    gatewayAlreadyOnboarded:
      "网关已存在。\n使用此入门密钥的网关已在 Things OS 中注册。您无法再次添加它。",
    gatewayConnectionNotEstablished: "找不到网关，或网关未重新连接。",
    continueMachineOnboardingDisabled: "Gateway onboarding in progress",
    operationPendingWarningMessage:
      "连接状态仍为 IDLE 或 IN_PROGRESS - 如果流程成功完成，源可能会出现在列表中。",
    retry: "重试",
    onboardAnotherGateway: "接入另一个网关",
    showProtocol: "显示协议",
    hideProtocol: "隐藏协议",
    getSupport: "获取支持",
    finishAndGoToGateway: "完成并前往新网关",
    continueMachineOnboarding: "继续机器入门",
    showGatewayDetails: "显示网关详情",
    gatewayId: "网关 ID",
    gatewayUuid: "网关 UUID",
    gatewayName: "网关名称",
    vendorId: "供应商 ID",
    model: "型号",
    createdAt: "创建时间",
    lastSeen: "最后上线",
    errorLabel: "错误",
    statusIconAltText: "状态",
    invalidOnboardingKeyErrorMessage:
      "入门密钥必须至少 25 个字符长，并且只能包含字母、数字和连字符。",
  },
};

export const addNewGatewayDrawerModalIt = {
  [pageNameKey]: {
    title: "Aggiunta del gateway",
    caretAltText: "Caret",
    gatewayOnboardingSection: "Onboarding del gateway",
    onboardingKey: "Chiave di onboarding",
    help: "Aiuto",
    onboardingKeyHelpText:
      "Trovi la Chiave di Onboarding stampata sul dispositivo Gateway.\nEsempio: 000001918012-000000022944",
    connectGatewayButton: "Connetti gateway",
    announcingGateway: "Il gateway si sta annunciando a Things OS",
    onboardingGateway: "Onboarding del gateway",
    announcedSuccess: "Il gateway è annunciato a Things OS",
    onboardedSuccess: "Il gateway è onboarded",
    announceFailed: "Impossibile annunciare il gateway a Things OS.",
    onboardFailed: "Onboarding del gateway non riuscito",
    connectionFailed: "Connessione non riuscita",
    gatewayAlreadyOnboarded:
      "Il gateway esiste già.\nUn gateway con questa chiave di onboarding è già registrato in Things OS. Non è possibile aggiungerlo di nuovo.",
    gatewayConnectionNotEstablished:
      "Il gateway non è stato trovato o non si è riconnesso.",
    continueMachineOnboardingDisabled: "Gateway onboarding in progress",
    operationPendingWarningMessage:
      "Lo stato della connessione e ancora IDLE o IN_PROGRESS - L'origine potrebbe comparire nell'elenco se il processo viene completato correttamente.",
    retry: "Riprova",
    onboardAnotherGateway: "Onboard un altro gateway",
    showProtocol: "Mostra protocollo",
    hideProtocol: "Nascondi protocollo",
    getSupport: "Ottieni supporto",
    finishAndGoToGateway: "Termina e vai al nuovo gateway",
    continueMachineOnboarding: "Continua onboarding macchina",
    showGatewayDetails: "Mostra dettagli gateway",
    gatewayId: "ID gateway",
    gatewayUuid: "UUID gateway",
    gatewayName: "Nome gateway",
    vendorId: "ID fornitore",
    model: "Modello",
    createdAt: "Creato il",
    lastSeen: "Ultimo accesso",
    errorLabel: "Errore",
    statusIconAltText: "Stato",
    invalidOnboardingKeyErrorMessage:
      "La chiave di onboarding deve essere lunga almeno 25 caratteri e può includere solo lettere, numeri e trattini.",
  },
};

export const addNewGatewayDrawerModalEs = {
  [pageNameKey]: {
    title: "Añadiendo gateway",
    caretAltText: "Caret",
    gatewayOnboardingSection: "Incorporación del gateway",
    onboardingKey: "Clave de incorporación",
    help: "Ayuda",
    onboardingKeyHelpText:
      "Encontrará la Clave de Incorporación impresa en el dispositivo Gateway.\nEjemplo: 000001918012-000000022944",
    connectGatewayButton: "Conectar gateway",
    announcingGateway: "El gateway se está anunciando a Things OS",
    onboardingGateway: "Incorporación del gateway",
    announcedSuccess: "El gateway está anunciado a Things OS",
    onboardedSuccess: "El gateway está incorporado",
    announceFailed: "No se pudo anunciar el gateway a Things OS.",
    onboardFailed: "No se pudo incorporar el gateway",
    connectionFailed: "Conexión fallida",
    gatewayAlreadyOnboarded:
      "El gateway ya existe.\nUn gateway con esta clave de incorporación ya está registrado en Things OS. No puedes añadirlo de nuevo.",
    gatewayConnectionNotEstablished:
      "No se encontró la puerta de enlace o no se reconectó.",
    continueMachineOnboardingDisabled: "Gateway onboarding in progress",
    operationPendingWarningMessage:
      "El estado de la conexion sigue en IDLE o IN_PROGRESS - El origen podria aparecer en la lista si el proceso finaliza correctamente.",
    retry: "Reintentar",
    onboardAnotherGateway: "Incorporar otro gateway",
    showProtocol: "Mostrar protocolo",
    hideProtocol: "Ocultar protocolo",
    getSupport: "Obtener soporte",
    finishAndGoToGateway: "Finalizar e ir al nuevo gateway",
    continueMachineOnboarding: "Continuar incorporación de máquina",
    showGatewayDetails: "Mostrar detalles del gateway",
    gatewayId: "ID del gateway",
    gatewayUuid: "UUID del gateway",
    gatewayName: "Nombre del gateway",
    vendorId: "ID del proveedor",
    model: "Modelo",
    createdAt: "Creado el",
    lastSeen: "Última conexión",
    errorLabel: "Error",
    statusIconAltText: "Estado",
    invalidOnboardingKeyErrorMessage:
      "La clave de incorporación debe tener al menos 25 caracteres y solo puede incluir letras, números y guiones.",
  },
};

export const addNewGatewayDrawerModalNl = {
  [pageNameKey]: {
    title: "Gateway toevoegen",
    caretAltText: "Pijl",
    gatewayOnboardingSection: "Gateway-onboarding",
    onboardingKey: "Onboarding-sleutel",
    help: "Help",
    onboardingKeyHelpText:
      "U vindt de Onboarding-sleutel afgedrukt op het Gateway-apparaat.\nVoorbeeld: 000001918012-000000022944",
    connectGatewayButton: "Gateway verbinden",
    announcingGateway: "Gateway wordt aangemeld bij Things OS",
    onboardingGateway: "Gateway-onboarding",
    announcedSuccess: "Gateway is aangemeld bij Things OS",
    onboardedSuccess: "Gateway is gekoppeld",
    announceFailed: "Gateway aanmelden bij Things OS is mislukt.",
    onboardFailed: "Gateway-onboarding is mislukt",
    connectionFailed: "Verbinding mislukt",
    gatewayAlreadyOnboarded:
      "De gateway bestaat al.\nEen gateway met deze onboarding-sleutel is al geregistreerd in Things OS. U kunt deze niet opnieuw toevoegen.",
    gatewayConnectionNotEstablished:
      "De gateway kon niet worden gevonden of maakte geen nieuwe verbinding.",
    continueMachineOnboardingDisabled: "Gateway onboarding in progress",
    operationPendingWarningMessage:
      "De verbindingsstatus is nog IDLE of IN_PROGRESS - De bron kan in de lijst verschijnen als het proces succesvol wordt afgerond.",
    retry: "Opnieuw proberen",
    onboardAnotherGateway: "Nog een gateway onboarden",
    showProtocol: "Protocol tonen",
    hideProtocol: "Protocol verbergen",
    getSupport: "Ondersteuning krijgen",
    finishAndGoToGateway: "Voltooien en naar nieuwe gateway",
    continueMachineOnboarding: "Doorgaan met machine-onboarding",
    showGatewayDetails: "Gatewaydetails tonen",
    gatewayId: "Gateway-ID",
    gatewayUuid: "Gateway-UUID",
    gatewayName: "Gatewaynaam",
    vendorId: "Leverancier-ID",
    model: "Model",
    createdAt: "Aangemaakt op",
    lastSeen: "Laatst gezien",
    errorLabel: "Fout",
    statusIconAltText: "Status",
    invalidOnboardingKeyErrorMessage:
      "Onboarding-sleutel moet minimaal 25 tekens bevatten en mag alleen letters, cijfers en koppeltekens bevatten.",
  },
};

export const addNewGatewayDrawerModalTr = {
  [pageNameKey]: {
    title: "Ağ Geçidi Ekleme",
    caretAltText: "Şapka",
    gatewayOnboardingSection: "Ağ Geçidine Katılım",
    onboardingKey: "İlk Katılım Anahtarı",
    help: "Yardım",
    onboardingKeyHelpText:
      "Giriş Anahtarını Ağ Geçidi cihazının üzerinde basılı olarak bulabilirsiniz. Örnek: 000001918012-000000022944",
    connectGatewayButton: "Ağ Geçidini Bağla",
    announcingGateway: "Ağ geçidi Things OS'a duyuruyor",
    onboardingGateway: "Ağ geçidine katılım",
    announcedSuccess: "Gateway Things OS'a duyuruldu",
    onboardedSuccess: "Ağ geçidi eklendi",
    announceFailed: "Gateway, Things OS'ye duyuru yapamadı.",
    onboardFailed: "Ağ geçidi eklenemedi",
    connectionFailed: "Bağlantı başarısız oldu",
    gatewayAlreadyOnboarded:
      "Ağ geçidi zaten mevcut.\nBu ilk katılım anahtarına sahip bir ağ geçidi Things OS'de zaten kayıtlı. Tekrar ekleyemezsiniz.",
    operationPendingWarningMessage:
      "Bağlantı durumu hala IDLE veya IN_PROGRESS durumunda - İşlem başarıyla tamamlanırsa kaynağın listede göründüğünü görebilirsiniz.",
    retry: "Yeniden dene",
    onboardAnotherGateway: "Başka bir ağ geçidine bağlanın",
    showProtocol: "Protokolü Göster",
    hideProtocol: "Protokolü Gizle",
    getSupport: "Destek Alın",
    finishAndGoToGateway: "Bitirin ve yeni Ağ Geçidine gidin",
    continueMachineOnboarding: "Makineye Eklemeye Devam Et",
    showGatewayDetails: "Ağ Geçidi Ayrıntılarını Göster",
    gatewayId: "Ağ Geçidi Kimliği",
    gatewayUuid: "Ağ Geçidi UUID'si",
    gatewayName: "Ağ Geçidi Adı",
    vendorId: "Satıcı Kimliği",
    model: "Modeli",
    createdAt: "Oluşturulma Tarihi",
    lastSeen: "Son Görülme",
    errorLabel: "Hata",
    statusIconAltText: "Durum",
    invalidOnboardingKeyErrorMessage:
      "İlk katılım anahtarı en az 25 karakter uzunluğunda olmalı ve yalnızca harf, sayı ve kısa çizgi içermelidir.",
    gatewayConnectionNotEstablished:
      "Ağ geçidi bulunamadı veya yeniden bağlanmadı.",
    continueMachineOnboardingDisabled: "Ağ geçidine katılım devam ediyor.",
  },
};
